export const pageview = (url: string) => {
  const GA_ID = process.env.NEXT_PUBLIC_GA_ID;
  if (!GA_ID || typeof window.gtag !== 'function') return;
  window.gtag('config', GA_ID, {
    page_path: url,
  });
};
